import request from '@/utils/request'

/**
 * 登录
 */
export function _login(data) {
  // OAuth2验证
  const formData = new FormData()
  formData.append('username', data.username)
  formData.append('password', data.password)
  return request({
    url: process.env.VUE_APP_TOKEN_URL,
    method: 'post',
    data: formData
  })
}
/**
 * 登出
 * TODO：服务端目前没设接口
 */
// export function _logout() {
//   return request({
//     url: '/logout',
//     method: 'get'
//   })
// }

/**
 * 获取登录用户的个人信息
 */
export function _getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}
